<template>
  <div class="empty-company-contacts fonte">
    <v-icon size="42" color="#9aa7a0">mdi-card-account-phone-outline</v-icon>
    <strong>Nenhum contato cadastrado</strong>
    <span>Cadastre telefones para entrega, acompanhamento e orcamentos.</span>
    <v-btn small dark :color="$theme.primary" @click="iniciarCadastro">
      <v-icon left small>mdi-plus</v-icon>
      Novo contato
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    iniciarCadastro: {
      type: Function,
      default: () => {}
    }
  }
};
</script>

<style scoped>
.empty-company-contacts {
  align-items: center;
  color: #65746b;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  min-height: 260px;
  padding: 20px;
  text-align: center;
}

.empty-company-contacts strong {
  color: #263238;
}
</style>
